import KpFavouritesPage from './KpFavouritesPage.svelte';
import type {FavouritesCollectionService} from './favourites-collection.service';
import type {RecordCollectionManager} from '../../record-collections/record-collection-manager';
import type {RecordCollectionsDataService} from '../../record-collections/record-collections.data-service';
import type {RecordCollectionViewConfiguration} from 'typings/portaro.fe.types';

export default class FavouritesController {

    public kpFavouritesPageComponent = KpFavouritesPage;

    public static async getConfiguration(favouritesCollectionService: FavouritesCollectionService, recordCollectionsDataService: RecordCollectionsDataService) {
        const manager = await favouritesCollectionService.getFavouritesCollectionManager();
        return recordCollectionsDataService.getPageSettings(manager.getRecordCollection().id);
    }

    public static preloadFavouritesCollectionManager(favouritesCollectionService: FavouritesCollectionService) {
        return favouritesCollectionService.getFavouritesCollectionManager();
    }

    /*@ngInject*/
    constructor(public viewConfiguration: RecordCollectionViewConfiguration,
                public recordCollectionManager: RecordCollectionManager) {
    }
}
